import { BottomNavigation, Button, Stack, useTheme } from "@mui/material"
import { CommonBtn } from "../../../components";

interface BottomSaveBarProps {
    onSave: () => void;
    childrenActions?: React.ReactNode
}

const BottomSaveBar: React.FC<BottomSaveBarProps> = ({ onSave, childrenActions }) => {
    const theme = useTheme();
    return (
        <BottomNavigation showLabels sx={{
            position: 'fixed', top: 70, left: 0, right: 0, zIndex: 1, justifyContent: "flex-end", height: 0 }}>
            <Stack sx={{
                width: "100%", height: "100%", 
                //backgroundImage: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${theme.palette.CommonBlack.main} 100%)`,
                backgroundSize: '100% 100%', // adjust the size to your liking
                backgroundPosition: '0% 0%',
                backgroundRepeat: 'no-repeat',
                justifyContent: "flex-end",
                alignItems: "flex-end",
                flexDirection:"row"
            }}>
                {childrenActions}
                <CommonBtn variant='contained' sx={{ margin: 2, borderRadius: 10, padding: 2, minWidth: 150 }} onClick={onSave} >Save</CommonBtn>
            </Stack>
        </BottomNavigation>
    )
}

export { BottomSaveBar };